import { showCart } from '../cart/cart.js';

//Hide and show tabs content
document.querySelectorAll('.item-details__description__tabs__tab').forEach(function (tab) {
  tab.addEventListener('click', function () {
    var target = tab.getAttribute('data-target');
    document.querySelectorAll('.item-details__description__tabs__tab').forEach(function (t) {
      t.classList.remove('active');
    });
    document.querySelectorAll('.item-details__description__content').forEach(function (content) {
      content.classList.remove('visible');
    });

    tab.classList.add('active');
    console.log(target);
    document.querySelector('.item-details__description__' + target).classList.add('visible');
  });
});


const cartSelectors = [
  '.item-details__dates__list__item__link',
  '.item-details__ticket-cta a',
  '.item-details__pakket-ticket a'
];

cartSelectors.forEach(selector => {
  document.querySelectorAll(selector).forEach(link => {
    link.addEventListener('click', function (e) {
      var url = link.getAttribute('href');
      document.querySelector('#cart__iframe').setAttribute('src', url);
      e.preventDefault();
      showCart();
    });
  });
});

var datesToggle = document.querySelector('.item-details__dates-toggle');
if (datesToggle) {
  var originalText = datesToggle.textContent;
  datesToggle.addEventListener('click', function () {
    var dates = document.querySelector('.item-details__dates');
    if (dates.classList.contains('visible')) {
      dates.classList.remove('visible');
      datesToggle.textContent = originalText;
    } else {
      dates.classList.add('visible');
      window.scrollTo({
        top: dates.getBoundingClientRect().top + window.scrollY - 100,
        behavior: 'smooth'
      });
      datesToggle.textContent = 'sluit tijden';
    }
  });
}


var backButton = document.querySelector('.item-details__back');
if (backButton) {
  
    if (window.history.length > 1 && document.referrer.includes(window.location.hostname)) {
      backButton.addEventListener('click', function () {
        window.history.back();
      });
    } else {
      console.log('No history to go back to.');
      backButton.style.display = 'none';
    }
}